export default "__VITE_ASSET__bb6VHiil__"